import moment from 'moment';

export const areRequired = (values: any, names: string[]): object => {
    return names.reduce((prev: object, name: string) => {
        if (!values[name]) {
            prev[name] = 'Field cannot be empty';
        }
        return prev;
    }, {});
};

export const email = (value: string) =>
    value && !/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/i.test(value)
        ? 'Invalid email address'
        : undefined;

export const required = (value: string) => (value ? undefined : 'This field is required');

export const commas = (value: string) =>
    value && !/^\w+(?:,\w+)*$/.test(value)
        ? 'Value should match a pattern: word1,word2 and so on'
        : undefined;

export const isValidDate = (value: string) => {
    return value && moment(value).isValid()?moment(value).isValid():false
}

export const isValidNumber = (value: string | number) => {
    return Boolean(typeof value === 'number') ||
        Boolean(value && typeof value === 'string' && !isNaN(Number(parseFloat(value))))
}

export const isEmptyError = (value: string | string[], defaultValue: string) => {
    if((value && Array.isArray(value) && value.length > 0) ||
        (value && !Array.isArray(value) && value !== '')) {
        return value
    }
    return defaultValue
}